// Actions enum for team operations
export enum ACTIONS {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  ASSIGN = 'assign',
  UNASSIGN = 'unassign',
  KEEP_CONVERSATION = 'KEEP_CONVERSATION',
  REDIRECT_AND_NOTIFY = 'REDIRECT_AND_NOTIFY',
}

// Team interface for frontend
export interface Team {
  _id: string;
  name: string;
  description?: string;
  business_id: string;
  created_by: string;
  members: Array<{
    user_id: string;
    role: 'admin' | 'member';
    added_at: string;
  }>;
  permissions: {
    agents: ACTIONS[];
    conversations: ACTIONS[];
    campaigns: ACTIONS[];
    settings: ACTIONS[];
  };
  created_at: string;
  updated_at: string;
}

// Tag interface for teams and other entities
export interface Tag {
  _id: string;
  name: string;
  color: string;
  business_id: string;
  type: 'conversation' | 'contact' | 'campaign' | 'general';
  created_by: string;
  created_at: string;
  metadata?: {
    description?: string;
    usage_count?: number;
  };
}

// Team member interface
export interface TeamMember {
  _id: string;
  team_id: string;
  user_id: string;
  role: 'admin' | 'member';
  permissions?: string[];
  added_by: string;
  added_at: string;
  status: 'active' | 'pending' | 'inactive';
}

// Profile Attribute types
export type DataType = 'text' | 'number' | 'boolean' | 'date' | 'closelist' | 'openlist';

export interface ProfileAttribute {
  id?: string;
  name: string;
  dataType: DataType;
  description?: string;
  useAI: boolean;
  closelist?: {
    options: string[];
    multiple: boolean;
  };
}
